import React from 'react'
import { render } from 'react-dom'
import { createStore } from 'redux'
import { Provider } from 'react-redux'
import App from './components/app'
import reducers from './reducers'
import * as firebase from 'firebase'
import 'whatwg-fetch'
// import './styles/app.scss'

// firebase
var config = {
  apiKey: process.env.FCM_API_KEY,
  authDomain: process.env.FCM_AUTH_DOMAIN,
  databaseURL: process.env.FCM_DB_URL,
  storageBucket: process.env.FCM_STORAGE_BUCKET,
  messagingSenderId: process.env.FCM_SENDER_ID,
};

var API_BASE = process.env.NODE_ENV == 'production' ? 'https://api.mrjotto.com' : 'http://localhost:3000'

firebase.initializeApp(config)
const messaging = firebase.messaging()

if (navigator.serviceWorker) {
  navigator.serviceWorker.register('/public/sw.js')
  .then(registration => {
    messaging.useServiceWorker(registration)
    return messaging.requestPermission()
  })
  .then(() => {
    return messaging.getToken()
  })
  .then(token => {
    // if (window.fcmToken) { return }
    fetch(`${API_BASE}/user/pushtoken`, {
      method: 'POST',
      body: JSON.stringify({ token }),
      credentials: 'include',
      mode: 'cors',
      headers: new Headers({
        'Content-Type': 'application/json'
      }),
    }).then(res => res.json())
      .then(res => {
        if (res.result == 'ok') {
          window.fcmToken = token
        } else {
          // console.log('fcm err', res)
        }
      })
      .catch(err => console.log('error sending token', err))
  })
  .catch(err => console.log('notifications', 'error: ', err))
}

let store = createStore(reducers)

render((
  <Provider store={store}>
    <App messaging={messaging} />
  </Provider>
), document.getElementById('main'))



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/